export default __webpack_public_path__ + "static/media/nice2Dark.e7250338.svg";